/**
 * ProgressAhaRibbon — the "shortlist crossed 3 items" nudge.
 *
 * Delegates to the shared <AhaRibbon /> component so the copy is
 * A/B-tracked alongside the other sign-in prompts. The only concern
 * here is: watch the compare-shortlist localStorage bucket and hand a
 * `visible` flag to AhaRibbon when it has ≥ 3 items.
 */
import { useEffect, useState } from "react";
import AhaRibbon from "@/components/AhaRibbon";

const SHORTLIST_KEY = "wua:compareShortlist";
const SHORTLIST_EVT = "wua:compareShortlist:change";
const THRESHOLD = 3;

function readShortlistCount() {
  try {
    const raw = localStorage.getItem(SHORTLIST_KEY);
    if (!raw) return 0;
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.length : 0;
  } catch { return 0; }
}

export default function ProgressAhaRibbon() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(readShortlistCount() >= THRESHOLD);
    check();
    window.addEventListener(SHORTLIST_EVT, check);
    window.addEventListener("storage", check);
    return () => {
      window.removeEventListener(SHORTLIST_EVT, check);
      window.removeEventListener("storage", check);
    };
  }, []);

  return (
    <AhaRibbon
      storageKey="wua:aha:shortlist-3:v1"
      testId="progress-aha-ribbon"
      visible={visible}
      benefit={{
        title:    "Nice — you've built real progress.",
        subtitle: "Save your shortlist to any device and get deadline reminders.",
      }}
      urgency={{
        title:    "Your shortlist lives only on this device.",
        subtitle: "One click sync — never lose your top picks to a browser wipe.",
      }}
    />
  );
}
